const GET_API_KEYS_LIST = 'dofe-bo/api_keys/GET_API_KEYS_LIST'
const GET_API_KEYS_LIST_SUCCESS = 'dofe-bo/api_keys/GET_API_KEYS_LIST_SUCCESS'
const GET_API_KEYS_LIST_FAIL = 'dofe-bo/api_keys/GET_API_KEYS_LIST_FAIL'

const DELETE_API_KEY = 'dofe-bo/api_keys/DELETE_API_KEY'
const DELETE_API_KEY_SUCCESS = 'dofe-bo/api_keys/DELETE_API_KEY_SUCCESS'
const DELETE_API_KEY_FAIL = 'dofe-bo/api_keys/DELETE_API_KEY_FAIL'

const ADD_API_KEY = 'dofe-bo/api_keys/ADD_API_KEY'
const ADD_API_KEY_SUCCESS = 'dofe-bo/api_keys/ADD_API_KEY_SUCCESS'
const ADD_API_KEY_FAIL = 'dofe-bo/api_keys/ADD_API_KEY_FAIL'

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case GET_API_KEYS_LIST:
      return {
        loading: true
      }
    case GET_API_KEYS_LIST_SUCCESS:
      return {
        loading: false,
        loaded: true,
        list: action.result.list
      }
    case GET_API_KEYS_LIST_FAIL:
      return {
        loading: false,
        loaded: false,
        list: [],
        error: action.error
      }
    default:
      return state
  }
}

export function getOrganizationApiKeys(organizationId) {
  return {
    types: [GET_API_KEYS_LIST, GET_API_KEYS_LIST_SUCCESS, GET_API_KEYS_LIST_FAIL],
    promise: client =>
      client.post(
        `apiv2/api-key/organization/${organizationId}/list`
      )
  }
}

export function deleteApiKey(id) {
  return {
    types: [DELETE_API_KEY, DELETE_API_KEY_SUCCESS, DELETE_API_KEY_FAIL],
    promise: client =>
      client.post(
        `apiv2/api-key/${id}/delete`
      )
  }
}

export function addApiKey(organizationId) {
  return {
    types: [ADD_API_KEY, ADD_API_KEY_SUCCESS, ADD_API_KEY_FAIL],
    promise: client =>
      client.put(
        `apiv2/api-key/create`,
        {
          data: {
            organizationId
          }
        }
      )
  }
}
